module.exports = function () {
  return require('lodash').cloneDeep(require('./defaultConfig.stub.js'));
};